import { Injectable, inject } from '@angular/core';
import { MenuGroups, MenuItem } from './menu-item.interface';
import { AuthService } from '@auth/services/auth.service';
import { AppService } from '../../app.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private authService = inject(AuthService);
  private appService = inject(AppService);

  private menuItems: MenuItem[] = [
    {
      path: '/assignments',
      label: 'Opdrachten',
      icon: 'assignments',
      scope: 'municipality',
    },
    {
      path: '/requests',
      label: 'Terugname aanvragen',
      icon: 'requests',
      scope: 'municipality',
    },
    {
      path: '/dashboard',
      label: 'Dashboard',
      icon: 'dashboard',
      scope: 'municipality',
    },
    {
      path: '/municipality-documents',
      label: 'Documenten',
      icon: 'document-text',
      scope: 'municipality',
    },
    {
      path: '/knowledge-items',
      label: 'Kennisbank',
      icon: 'document-text',
      roles: ['ADMIN', 'BACKOFFICE'],
      scope: 'general',
    },
    {
      path: '/customer-app-users',
      label: 'App-gebruikers',
      icon: 'person',
      roles: ['ADMIN'],
      scope: 'general',
    },
    {
      path: '/employees',
      label: 'Medewerkers',
      icon: 'employees',
      roles: ['ADMIN', 'KEY_USER'],
      scope: 'municipality',
    },
    {
      path: '/settings',
      label: 'Beheer',
      icon: 'settings',
      roles: ['ADMIN', 'BACKOFFICE'],
      scope: 'general',
    },
  ];

  getMenuGroups(): MenuGroups {
    const visible = this.menuItems.filter((item) => this.canShowItem(item));

    return {
      general: visible.filter((item) => item.scope === 'general'),
      municipality: visible.filter((item) => item.scope === 'municipality'),
    };
  }

  private canShowItem(item: MenuItem): boolean {
    if (!item.roles) {
      return true;
    }

    if (item.roles.includes('ADMIN') && this.authService.isAdmin()) {
      return true;
    }

    if (item.roles.includes('BACKOFFICE') && this.authService.isBackoffice()) {
      return true;
    }

    if (item.roles.includes('KEY_USER') && this.appService.isKeyUser()) {
      return true;
    }

    if (item.roles.includes('CONSULENT') && this.appService.isConsulent()) {
      return true;
    }

    return false;
  }
}
